import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './index.less';

const cx = classNames.bind(styles);

const defaultProps = {
  title: '',
  children: null
};
const propTypes = {
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  children: PropTypes.any
};

const TagsContainer = ({ title, children }) => (
  <div className={cx('tagsContainer')}>
    <h3 className={cx('title')}>{title}</h3>
    <div className={cx('body')}>{children}</div>
  </div>
);

TagsContainer.defaultProps = defaultProps;
TagsContainer.propTypes = propTypes;
export default TagsContainer;



// WEBPACK FOOTER //
// ./src/components/ui/Containers/TagsContainer.jsx